<template>
    <section class="section_about">
        <div class="slider_img">
          <div @click="showPrevAboutSlider" class="slider_back_about prev_next_class"><i class="ri-arrow-left-s-line "></i></div>
           <VueSlickCarousel v-bind="settings" ref="carouselAboutSlider" class="slick_about">
              <img src= '@/assets/images/slider1.png' />
              <img src= '@/assets/images/slider1.png' />
              <img src= '@/assets/images/slider1.png' />
           </VueSlickCarousel>
           <div @click="showNextAboutSlider" class="slider_next_about prev_next_class"><i class="ri-arrow-right-s-line"></i></div>
        </div>
        <div class="content_about">
            <div class="text_about">
              <div class="title_text_about">
                {{ $t('restaurant_exotic') }}
              </div>
              <div class="desc_text_about">
                {{ $t('restaurant_exotic_desc') }}
              </div>
            </div>
            <div class="img_about_content"><img src= '@/assets/images/about_us_1.png' /></div>
            <div class="text2_about">
                <div class="title2_about">{{ $t('story') }}</div>
                <div class="desc2_about">
                  {{ $t('story_text') }}
                </div>

            </div>
            <div class="img_about_content"><img src= '@/assets/images/about_us_2.png' /></div>
            <div class="text3_about">
              {{ $t('about_text') }}
            </div>
        </div>
    </section>

</template>


<script>
   import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  export default {
    name: 'MyComponent',
    metaInfo() {
        return { 
            title: "Despre Tiki Bistro | Livrări și take-away",
            meta: [
                { name: 'description', content:  'Un loc unde se mănâncă biiine de tot, mereu plin de prieteni, un loc unde putem lucra dacă avem laptopul cu noi, dar să și petrecem.'},
                { property: 'og:title', content: "Despre Tiki Bistro | Livrări și take-away"},
                { property: 'og:description', content: 'Un loc unde se mănâncă biiine de tot, mereu plin de prieteni, un loc unde putem lucra dacă avem laptopul cu noi, dar să și petrecem.'},
                { property: 'og:site_name', content: 'Tiki Bistro'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    },
    components: { VueSlickCarousel       
          },
    methods: {
      showNextAboutSlider() {
        this.$refs.carouselAboutSlider.next() 
      },
      showPrevAboutSlider() {
        this.$refs.carouselAboutSlider.prev() 
      },
    },
    data() {
      return {
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
        },
       
      }
    },
   
    
  }
  
</script>
